import FormVM from './form-vm';
export default {
  init: function() {
    console.log('CourseworkEntryForm initialization function called');

    var coursework_data = JSON.parse($('#coursework_json').val());
    var coursework_entry_data = JSON.parse($('#coursework_entry_json').val());
    var $media = $('#attachment_media_json');

    var vm = new FormVM({coursework: coursework_data, coursework_entry: coursework_entry_data});

    //modify an existing templateEngine to work with string templates
    var createStringTemplateEngine = function(templateEngine, templates) {
      templateEngine.makeTemplateSource = function(template) {
        return new ko.templateSources.stringTemplate(template, templates);
      };
      return templateEngine;
    };

      //make this new template engine our default engine
    ko.setTemplateEngine(createStringTemplateEngine(new ko.nativeTemplateEngine(), vm.templates));
    ko.applyBindings(vm, document.getElementById('coursework_entry_form'));
  }
};

